import { render, staticRenderFns } from "./EmployeeAssets.vue?vue&type=template&id=415e276c"
import script from "./EmployeeAssets.vue?vue&type=script&lang=js"
export * from "./EmployeeAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports